import { render, staticRenderFns } from "./beschreibung-tooltip.vue?vue&type=template&id=6eca2a8b&scoped=true"
import script from "./beschreibung-tooltip.vue?vue&type=script&lang=js"
export * from "./beschreibung-tooltip.vue?vue&type=script&lang=js"
import style0 from "./beschreibung-tooltip.vue?vue&type=style&index=0&id=6eca2a8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eca2a8b",
  null
  
)

export default component.exports